import React from 'react';
import { X } from 'lucide-react';
import { TEMPLATES } from '../utils/templates';

export function TemplatePickerModal({ isOpen, onClose, onSelectTemplate }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
      <div className="bg-surface rounded-lg border border-border max-w-2xl w-full max-h-[80vh] overflow-y-auto">
        <div className="sticky top-0 bg-surface border-b border-border p-4 flex items-center justify-between">
          <h2 className="text-lg font-semibold text-foreground">Choose a Template</h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-background rounded-lg transition-colors"
            aria-label="Close"
          >
            <X className="w-5 h-5 text-text-muted" />
          </button>
        </div>

        <div className="p-4 space-y-3">
          {TEMPLATES.map((template) => (
            <div
              key={template.id}
              className="bg-background border border-border rounded-lg p-4 hover:border-primary transition-colors"
            >
              <div className="flex items-start gap-3">
                <span className="text-3xl">{template.icon}</span>
                <div className="flex-1">
                  <h3 className="text-base font-medium text-foreground mb-1">
                    {template.title}
                  </h3>
                  <p className="text-sm text-text-muted mb-3">
                    {template.description}
                  </p>
                  <button
                    onClick={() => onSelectTemplate(template.id)}
                    className="px-4 py-2 bg-primary text-white text-sm rounded-lg hover:bg-primary/90 transition-colors"
                  >
                    Use this template
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
